import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './quasar';
import { i18n } from './i18n';
import PortalVue from 'portal-vue';

// @ts-ignore
import VCalendar from 'v-calendar';
import { compass } from '@resclick/compass';
import QSelectDynamic from '@/components/QSelectDynamic.vue';
import QPhoneNumberInput from '@/components/QPhoneNumberInput.vue';
import crsForm from '@/plugins/crs-form';
import disableAutocomplete from '@/plugins/disable-autocomplete';

Vue.config.productionTip = false;

Vue.component('QSelectDynamic', QSelectDynamic);
Vue.component('QPhoneNumberInput', QPhoneNumberInput);
Vue.use(PortalVue);
Vue.use(VCalendar);
Vue.use(crsForm);
Vue.use(disableAutocomplete);

const formatCurrency = (value: string | number, minDigits = 2) => {
  if (typeof value !== 'number') {
    value = Number(value);
    if (!isFinite(value) || isNaN(value)) {
      value = 0;
    }
  }

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits: minDigits,
    maximumFractionDigits: minDigits,
    useGrouping: true,
  });

  return formatter.format(value);
};

Vue.filter('money', formatCurrency);

compass.httpConfig({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    // Authorization: `Bearer ${store.state?.auth?.accessToken}`,
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
